import * as React from 'react';
import lodash from 'lodash';

export default function useInfiniteScroll<T extends HTMLElement>(ref: T | null, callback: () => void) {
  const onScroll = React.useMemo(
    () => lodash.debounce(
      () => {
        if (ref && ref.scrollHeight - ref.scrollTop - ref.clientHeight <= 100) {
          callback();
        }
      },
      100,
    ),
    [callback, ref],
  );
  React.useEffect(() => {
    if (ref && ref.scrollHeight <= ref.clientHeight) {
      onScroll();
    }
  }, [ref, onScroll]);

  return { onScroll };
}
